import { AnyAction, Dispatch } from '@reduxjs/toolkit'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Web3 from 'web3'

import { useWeb3ModalAccount } from '@web3modal/ethers5/react'
import { loginThunk, reloginThunk } from '@/store/wallet'
import { localUserKey } from '@/entity/system.interface'

// 监控修改小狐狸的钱包地址
const useChangeAccount = (dispatch: Dispatch) => {
  const { address } = useWeb3ModalAccount()
  const navigator = useNavigate()
  useEffect(() => {
    if (address) {
      const provider = window.web3Modal.getWalletProvider()
      window.web3 = new Web3(provider)

      try {
        const info = sessionStorage.getItem(localUserKey)
        console.log('useChangeAccount address info', info)
        if (info) {
          const localUser = JSON.parse(info)
          if (localUser.currentAddress !== address) {
            // session有用户信息，切换账号登录
            dispatch(reloginThunk() as unknown as AnyAction)
              .unwrap()
              .then((res: any) => {
                if (!res?.nickname) {
                  navigator('/nickname')
                }
              })
          }
        } else {
          // session无用户信息，需要登录
          dispatch(loginThunk() as unknown as AnyAction)
            .unwrap()
            .then((res: any) => {
              if (!res?.nickname) {
                navigator('/nickname')
              }
            })
        }
      } catch (e) {
        console.log('no save user session', e)
      }
    }
  }, [address])
}
export default useChangeAccount
